function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 7H5.05v4.05H1v2.45h4.05v4.05H7.5V13.5h4.05v-2.45H7.5V7zM20.43 13.8c-.77.59-1.73.94-2.78.94-1.04 0-2-.35-2.77-.94l-1.83 1.08v2.67h9.2v-2.67l-1.82-1.08zM17.66 13.26a3.13 3.13 0 100-6.26 3.13 3.13 0 000 6.26z",
  fill: "current"
});

function SvgNewUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgNewUser;